/**
 * Subscription Rates page scripts
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';
import { resolveRoot } from '../shared/utils.js';

import $ from 'jquery';
import { addSeconds, formatDistanceToNowStrict } from 'date-fns';

import { PROGRAM } from '../shared/config.js';

injector.injectClass(class extends Script {
    onLoad() {
        if (PROGRAM === 'nss') {
            this.onLoadNss();
        } else {
            this.onLoadDefault();
        }
    }

    onLoadDefault() {
        const $cancelled = $('#cancel_time');
        if ($cancelled.length) {
            const cancelled = $cancelled.data('duration');
            const expire = addSeconds(new Date(), cancelled);
            $cancelled.html(formatDistanceToNowStrict(expire, {
                addSuffix: true,
            }));
        }
    }

    onLoadNss() {
        $('.edition-selection input').on('change', function () {
            const $selected = $('.edition-selection input:checked');
            const main = $selected.data('main');
            const audio = $selected.data('audio');
            const mainPrice = $selected.data('main-price');
            const audioPrice = $selected.data('audio-price');

            $('.signup-button.main').attr('href', resolveRoot(`signup/${main}`));
            $('.signup-button.audio').attr('href', resolveRoot(`signup/${audio}`));

            $('.signup-button.main .price').text(`$${mainPrice} USD`);
            $('.signup-button.audio .price').text(`$${audioPrice} USD`);

            $('.signup-button').removeClass('disabled');
        });

        // Sometimes the page loads with a radio button already checked.
        setTimeout(() => {
            $('.edition-selection input:checked').trigger('change');
        }, 250);
    }
}, ['subscription-rates']);
